import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PerformanceReviewProcessVisibilitySettingsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import TargetGroupDataTable from '../TargetGroup/TargetGroupDataTable'
import TargetManagementDataTable from './TargetManagementDataTable'

export const TargetManagement: React.FC<{
  review: PerformanceReviewProcessVisibilitySettingsFragment
}> = ({ review }) => {
  return (
    <Box gap="s32">
      <Box gap="s16">
        <Text size="400" color="grey1000" weight="semibold">
          {i18n.t('performance_process.reviews.target_management_title')}
        </Text>
        <Text size="300">
          {i18n.t('performance_process.reviews.target_management_description')}
        </Text>
      </Box>
      {review.status === 'scheduled' ? (
        <TargetGroupDataTable reviewId={review.id} />
      ) : (
        <TargetManagementDataTable reviewActive={review.status == 'active'} />
      )}
    </Box>
  )
}
